import ColorSelector from 'components/color-selector/ColorSelector';
import PanelPage from 'navigation/pages/PanelPage';
export default class ReturnsSelectColor extends PanelPage {
    id;
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            selector: ['.color-selector__products', ColorSelector]
        };
    }
    initialized() {
        super.initialized();
        this.el.parentElement.style.setProperty('--color-header-height', `${this.refs.selectColorHeader.offsetHeight}px`);
    }
}
